export default __webpack_public_path__ + "static/media/6.586f041a.png";